/**
 * 身份证号相关常量配置（全局只读）
 *
 * PROVINCE: 身份证号前两位对应的省份/地区编码映射
 *  - 11: 北京
 *  - 12: 天津
 *  - 13: 河北
 *  - 14: 山西
 *  - 15: 内蒙古
 *  - 21: 辽宁
 *  - 22: 吉林
 *  - 23: 黑龙江
 *  - 31: 上海
 *  - 32: 江苏
 *  - 33: 浙江
 *  - 34: 安徽
 *  - 35: 福建
 *  - 36: 江西
 *  - 37: 山东
 *  - 41: 河南
 *  - 42: 湖北
 *  - 43: 湖南
 *  - 44: 广东
 *  - 45: 广西
 *  - 46: 海南
 *  - 50: 重庆
 *  - 51: 四川
 *  - 52: 贵州
 *  - 53: 云南
 *  - 54: 西藏
 *  - 61: 陕西
 *  - 62: 甘肃
 *  - 63: 青海
 *  - 64: 宁夏
 *  - 65: 新疆
 *  - 71: 台湾
 *  - 81: 香港
 *  - 82: 澳门
 *  - 91: 国外
 *
 * SEX: 身份证号解析的性别映射
 *  - MAN: 男
 *  - WOMAN: 女
 */
export const ID_CARD: Record<string, any> = {
  // 身份证号对应的省
  PROVINCE: {
    11: "北京",
    12: "天津",
    13: "河北",
    14: "山西",
    15: "内蒙古",
    21: "辽宁",
    22: "吉林",
    23: "黑龙江",
    31: "上海",
    32: "江苏",
    33: "浙江",
    34: "安徽",
    35: "福建",
    36: "江西",
    37: "山东",
    41: "河南",
    42: "湖北",
    43: "湖南",
    44: "广东",
    45: "广西",
    46: "海南",
    50: "重庆",
    51: "四川",
    52: "贵州",
    53: "云南",
    54: "西藏",
    61: "陕西",
    62: "甘肃",
    63: "青海",
    64: "宁夏",
    65: "新疆",
    71: "台湾",
    81: "香港",
    82: "澳门",
    91: "国外",
  },
  // 性别
  SEX: {
    MAN: "男",
    WOMAN: "女",
  },
} as const;
